/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { FormInitialisationParameterType } from '../models/form-initialisation-parameter-type';
export interface FormInitialisationParameter {
  entityTypes?: Array<string> | null;
  field?: string | null;
  parameter?: string | null;
  type?: FormInitialisationParameterType;
}

export class FormInitialisationParameter {
  entityTypes?: string[] | null;
  field?: string | null;
  parameter?: string | null;
  type?: FormInitialisationParameterType;

  constructor(value: FormInitialisationParameter) {
    this.entityTypes = value?.entityTypes;
    this.field = value?.field;
    this.parameter = value?.parameter;
    this.type = value?.type ? Object.entries(Object.values(FormInitialisationParameterType)).flatMap((x) => x).find(x => x === value.type) as FormInitialisationParameterType : undefined;
  }
}
